import { render, staticRenderFns } from "./CoinInformation.vue?vue&type=template&id=6f9ed0d9"
import script from "./CoinInformation.vue?vue&type=script&lang=js"
export * from "./CoinInformation.vue?vue&type=script&lang=js"
import style0 from "./CoinInformation.vue?vue&type=style&index=0&id=6f9ed0d9&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports